// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: page hight tool
	
var style1 = "vh;height:" + 50 + "vh";
$w("#text23").html = "<" + "h1" + " style=" + style1 + ">" + $w("#text23").text + "</" + "h1" + ">";

});